document.addEventListener('alpine:init', () => {
  Alpine.data('VariantDropdown', () => ({
    cache: {},
    product: null,
    color_option: null,
    color_option_id: '',
    color_variants: [],
    current_variant_id: '',
    current_variant: null,  
    init() {
      this.InitCache();
      this.InitWatchers();
      this.InitSelf();
      this.SetCurrentVariant();
    },
    InitCache() {
      let am = this;
      am.cache.$product_form = am.$el.closest('product-form');
      am.cache.$variant_options = am.$el.closest('[data-name="options"]');
    },
    InitWatchers() {
      let am = this;
      am.$watch('current_variant_id', () => {
        am.SetCurrentVariant();
        am.e_CloseDropdown();
        am.SetMainFormVariant();
      });
    },
    InitSelf() {
      let am = this;
      am.product = JSON.parse(am.cache.$product_form.getAttribute('product'));
      am.color_option = JSON.parse(am.$el.dataset.color_option);
      am.current_variant_id = am.$el.dataset.current_variant_id;
      am.color_option_id = `option${ am.color_option.position }`;
      am.color_variants = am.color_option.values.map((value) => {
        let variant = am.product.variants.find(v => v[am.color_option_id] == value && v.featured_image);
        return variant;
      });
    },
    SetCurrentVariant() {
      let am = this;
      am.current_variant = am.product.variants.find(v => v.id == am.current_variant_id);
    },
    SetMainFormVariant() {
      let am = this;
      let color = am.current_variant[am.color_option_id];
      let $color = am.cache.$variant_options.querySelector(`input[value="${color}"]`);
      if (!$color) return;
      $color.checked = true;
      $color.dispatchEvent(new Event('change', {bubbles: true}));
    },
    e_CloseDropdown() {
      let am = this;
      am.$el.removeAttribute('open');
    },
    e_SetDropdownPosition() {
      let am = this;
      let offset = 200;
      let $list = am.$el.querySelector('ul');
      let is_atBottom = (window.innerHeight - am.$el.getBoundingClientRect().bottom) <= offset;
      $list.style.bottom = is_atBottom ? '100%' : 'auto';
    }
  }));

  Alpine.data('ProductImagesGallery', () => ({
    cache: {},
    init() {
      this.InitCache();
      this.InitSwiper();
      this.InitEvents();
    },
    InitCache() {
      let am = this;
      am.cache.$thumbs = am.$el.querySelector('.swiper-thumbs');
      am.cache.$main = am.$el.querySelector('.swiper-main');
    },
    InitSwiper() {
      let am = this;
      am.swiper_thumbs = new Swiper(am.cache.$thumbs, {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });

      am.swiper_main = new Swiper(am.cache.$main, {
        spaceBetween: 10,
        autoHeight: true,
        navigation: {
          nextEl: am.cache.$main.querySelector(".swiper-button-next"),
          prevEl: am.cache.$main.querySelector(".swiper-button-prev"),
        },
        thumbs: {
          swiper: am.swiper_thumbs,
        },
      });      
    },
    InitEvents() {
      let am = this;

      // on load
      let media_id = am.$el.dataset.onload_media_id;
      am.UpdateVariantMedia(media_id);

      // on variant change
      document.addEventListener(`${window.eight.constants.events["ARMADA:VARIANT:CHANGE"]}`, (e) => {
        // console.log(e);
        if (!e.detail.variant || !e.detail.variant.featured_media) return;

        let variant_media_id = e.detail.variant.featured_media.id;
        am.UpdateVariantMedia(variant_media_id);
      });
    },
    UpdateVariantMedia(media_id) {
      let am = this;
      let $media = am.cache.$main.querySelector(`.swiper-slide[data-media-id="${media_id}"]`);
      if (!$media) return;
      let slideIndex = $media.dataset.slideIndex;
      am.swiper_main.slideTo(slideIndex, false);
    }
  }));
});